import { t } from "../../lib/i18n";
import React from 'react';
import { Link } from 'react-router-dom';

const BottomCTA: React.FC = () => {
  return (
    <div className="mt-20 p-10 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-[40px] text-center text-white shadow-2xl relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path d="M0 100 L100 0 L100 100 Z" fill="white" />
        </svg>
      </div>
      
      <div className="relative z-10">
        <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight">
          {t("bottomCTA.k1")} <br className="hidden md:block" /> {t("bottomCTA.k2")} </h2>
        <p className="text-xl md:text-2xl opacity-90 mb-10 max-w-2xl mx-auto font-medium">
          {t("bottomCTA.k3")} </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link 
            to="/login" 
            className="w-full sm:w-auto px-10 py-5 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-xl rounded-2xl shadow-xl transition-all hover:scale-105 active:scale-95"
          >
            {t("bottomCTA.k4")} </Link>
          <p className="text-sm font-bold uppercase tracking-widest opacity-70">
            {t("bottomCTA.k5")} </p>
        </div>
      </div>
    </div>
  );
};

export default BottomCTA;
